import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@src/app/_redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { HeaderNav } from '@src/app/header/HeaderNav';
import { UserDropDown } from '@src/app/header/UserDropDown';
import { getLoggedInCustomer } from '@src/app/accounts/selectors';
import './header.scss';
import { cognitoLogout } from '@src/app/login/cognito/actions';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { bindActionCreators } from 'redux';
import { actionCreators } from '@src/app/user/actions';

const setupLogoContainer = (logoUrl: string, logo: string, fullWidthLogo: string) => {
  if (!logoUrl && !logo) {
    return 'hidden';
  } else {
    if (fullWidthLogo) {
      return '';
    } else {
      return 'client-logo container';
    }
  }
};
const setupBackgroundImage = path => {
  return {
    backgroundImage: 'url(' + path + ')',
  };
};
const setupLogoImageClass = fullWidthLogo => {
  if (fullWidthLogo) {
    return 'logo-image-wide no-print';
  } else {
    return 'logo-image no-print';
  }
};
const setupUserInfoClass = fullWidthLogo => {
  if (fullWidthLogo) {
    return 'user-info';
  } else {
    return 'user-info';
  }
};
interface Props extends RouteComponentProps {
  userName: any;
  isAuth: boolean;
  logout: any;
  headerBanner?: any;
  bannerAltText?: any;
  logo?: any;
  logoAltText?: any;
  assetUrl?: any;
  myloLogin: boolean;
  myloConfig: any;
  clientConfig: any;
  adminConfig: any;
  logoUrl?: any;
  leftNavOpen: boolean;
  leftNavOpenAction: any;
  myloPath: any;
  fullWidthLogo: any;
}

export const Header: React.SFC<Props> = props => {
  const onLogout = () => {
    const { history, myloLogin, myloConfig } = props;
    history.push('/login');
    cognitoLogout(myloLogin, myloConfig);
  };
  const onClickLeftNavOpen = () => {
    props.leftNavOpenAction({payload: !props.leftNavOpen});
  };
  const myloUrl = `${props.myloConfig.myloUiBaseUrl}${props.myloPath}?client_id=${props.myloConfig.clientId}`;
  return (
    <header className="main-header">
        <div className="header-inner">
          <div className={setupLogoContainer(props.logoUrl, props.logo, props.fullWidthLogo)}>
            {props.isAuth ? (
              <div className="main-nav-toggle" onClick={() => onClickLeftNavOpen()}><i className="pull-left fa fa-bars" /></div>
            ) : null}
            <div
              style={setupBackgroundImage(props.logoUrl ? props.logoUrl : props.assetUrl + '/' + props.logo)}
              className={setupLogoImageClass(props.fullWidthLogo)}
              title={props.logoAltText}
            />
            <div className={setupUserInfoClass(props.fullWidthLogo)}>
              {props.isAuth ? (
                <UserDropDown
                  userName={props.userName.address.name}
                  onClick={() => onLogout()}
                  myloLogin={props.myloLogin}
                  myloUrl={myloUrl}
                />
              ) : null}
            </div>
          </div>
          {!props.logoUrl && !props.logo ? (
            <div className="client-no-logo container">
              {props.isAuth ? (
                <div className="main-nav-toggle" onClick={() => onClickLeftNavOpen()}><i className="pull-left fa fa-bars" /></div>
              ) : null}
              <div className={setupUserInfoClass(props.fullWidthLogo)}>
                {props.isAuth ? (
                  <div>

                    <UserDropDown
                      userName={props.userName.address.name}
                      onClick={() => onLogout()}
                      myloLogin={props.myloLogin}
                      myloUrl={myloUrl} />
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
          <div className="no-print">
            <HeaderNav
              mode="horizontal"
              openAnimation="slide-up" 
              clientConfig={props.clientConfig}
              adminConfig={props.adminConfig}
            />
          </div>
          <div>
            {props.headerBanner && (
              <div
                style={setupBackgroundImage(
                  props.assetUrl + '/' + props.headerBanner,
                )}
                className="banner-image no-print"
                title={props.bannerAltText}
              />
            )}
          </div>

        </div>
    </header>
  );
};

const mapState = state => {
  let pageHeader = getAdminConfigTableItem(
    state.adminConfig,
    state.clientConfig,
    'PageHeader',
  );
  let availActions = getAdminConfigTableItem(
    state.adminConfig,
    state.clientConfig,
    'AvailableActions',
  );
  return {
    userName: getLoggedInCustomer(state) || 'Not Found',
    isAuth: state.auth.omsAuth.isLoginSuccessful,
    logo: pageHeader.LogoPath || null,
    logoAltText: pageHeader.LogoAltText || null,
    logoUrl: pageHeader.LogoUrl || null,
    headerBanner: pageHeader.BannerPath || null,
    bannerAltText: pageHeader.BannerAltText || null,
    fullWidthLogo: pageHeader.FullWidthLogo || false,
    myloLogin: state.auth.weakLogin.identityId !== 'initialid',
    myloConfig: state.clientConfig.clientConfig.myloConfig,
    assetUrl: state.clientConfig.clientConfig.userFilesBucket,
    clientConfig: state.clientConfig,
    adminConfig: state.adminConfig,
    leftNavOpen:  state.userState.leftNavOpen,
    myloPath: availActions.Preferences.myloAccountCustomPath || '/account',
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      leftNavOpenAction: actionCreators.leftNavOpen,
    },
    dispatch,
  );

export default connect(mapState, mapDispatchToProps)(withRouter(Header) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/header/Header.tsx